import { render, staticRenderFns } from "./compfecha.vue?vue&type=template&id=4123b960&scoped=true"
import script from "./compfecha.vue?vue&type=script&lang=js"
export * from "./compfecha.vue?vue&type=script&lang=js"
import style0 from "./compfecha.vue?vue&type=style&index=0&id=4123b960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4123b960",
  null
  
)

export default component.exports